<template>
  <section class="free-Time-saving-mobile">
    <div class="saving-mobile-background" :style="`backgroundColor: ${backgroundColor}`"></div>
    <div class="saving-mobile-sticky">
      <div ref="savingText" v-textMotion class="text-intro saving-mobile-text-intro">
        <p class="title">{{ $t('power-saving-title') }}</p>
        <p class="sub-title">
          {{ $t('power-saving-sub-title') }}
        </p>
        <p class="description">
          {{ $t('power-saving-description') }}
        </p>
      </div>
      <div
        class="wow textInPartMotion saving-mobile-phone-container"
        data-wow-duration=".7s"
        data-wow-delay="0.3s"
        data-wow-offset="100"
      >
        <img
          v-lazy="require('../../assets/fluent/phone-model-mobile.png')"
          alt="ColorOS 11"
          class="phone-model-mobile-img"
        />
        <img
          v-lazy="require('../../assets/fluent/saving-mobile-phone.png')"
          alt="ColorOS 11"
          class="saving-mobile-phone-img"
          :class="savingPhoneActive ? 'saving-show-phone' : ''"
        />
        <img
          v-if="!savingPhoneActive"
          v-lazy="require('../../assets/fluent/safe-mobile-phone.gif')"
          alt="ColorOS 11"
          class="safe-mobile-phone-img"
          :class="!savingPhoneActive ? 'saving-show-phone' : ''"
        />
      </div>
      <div
        v-textMotion="100"
        class="text-intro safe-saving-text-intro"
        :class="savingPhoneActive ? '' : 'safe-saving-text-white'"
      >
        <p class="title">{{ $t('night-safe-title') }}</p>
        <p class="sub-title">
          {{ $t('night-safe-sub-title') }}
        </p>
        <p class="description">
          {{ $t('night-safe-description') }}
        </p>
      </div>
    </div>
  </section>
</template>
<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';

import UpdateAnimationMixin from '../../mixins/updateAnimation';

export default {
  mixins: [UpdateAnimationMixin],
  data() {
    return {
      progress: 0,
      savingPhoneActive: true,
      backgroundColor: 'rgb(255,255,255)'
    };
  },
  watch: {
    progress(value) {
      if (value >= 0.75) this.savingPhoneActive = false;
      if (value <= 0.25) this.savingPhoneActive = true;
      const rate = Math.floor(255 - 241 * value);
      this.backgroundColor = `rgb(${rate}, ${rate}, ${rate})`;
    }
  },
  mounted() {
    this.resizeHandler();
    this.scene = new ScrollMagic.Scene({
      duration: 0.5 * window.innerHeight,
      triggerElement: '.free-Time-saving-mobile',
      triggerHook: 0,
      offset: this.$refs.savingText.clientHeight - 32
    })
      .setPin('.saving-mobile-sticky')
      .addTo(Controller)
      .on('progress', e => {
        this.updateBezier('progress', e.progress, 100);
      });
    window.addEventListener('resize', this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    resizeHandler() {
      if (this.scene) this.scene.offset(this.$refs.savingText.clientHeight - 32).duration(0.5 * window.innerHeight);
    }
  }
};
</script>
<style lang="scss">
.free-Time-saving-mobile {
  position: relative;
  overflow: hidden;
}
.saving-mobile-sticky {
  position: relative;
  z-index: 1;
}
.saving-mobile-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
}
.saving-mobile-text-intro .sub-title {
  /* max-width: 80%; */
}

.saving-mobile-phone-container {
  position: relative;
  width: 100%;
  text-align: center;
  img {
    position: relative;
    z-index: 2;
    width: 64.8vw;
    opacity: 0;
    transition: 0.3s linear;
  }
  .phone-model-mobile-img {
    z-index: 3;
    opacity: 1;
  }
  .saving-mobile-phone-img,
  .safe-mobile-phone-img {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin: auto;
  }
  .safe-mobile-phone-img {
    border-radius: 24px;
    transform: scale(0.97, 0.96);
    z-index: 1;
  }
  .saving-show-phone {
    opacity: 1;
  }
}
.safe-saving-text-intro p {
  transition: 0.3s linear;
}
.safe-saving-text-white {
  .title,
  .sub-title {
    color: #fff;
  }
  .description {
    color: rgba(255, 255, 255, 0.5);
  }
}
</style>
